<template>
  <div class="nav-search-no-results">
    <div class="tw-flex tw-flex-col tw-items-center tw-mt-4 tw-p-2">
      <font-awesome-icon icon="fa-regular fa-face-frown" class="tw-text-[50px] tw-mb-4" />
      <div class="tw-italic">No search results.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavSearchNoResults",
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.nav-search-no-results {
  padding-left: $nav-padding-side;
  padding-right: $nav-padding-side;
}
</style>
